import axios from "axios";

const serverURL = process.env.REACT_APP_API_ENDPOINT;

async function fetchData(url, method, postData = {}, headers = null) {
  try {
    const option = {
      url: serverURL + url,
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (Object.keys(postData).length) {
      option.data = postData;
    }

    if (headers) {
      option.headers = { ...option.headers, ...headers };
    }

    const response = await axios(option);
    if (response.status === 200) {
      return response;
    } else {
      throw Error(response.statusText);
    }
  } catch (err) {
    throw err;
  }
}

export const getCoupon = (couponValues) =>
  fetchData("http/coupon", "POST", couponValues);

export const onPay = (values) => fetchData("rest/charge", "POST", values);

export const getSurvey = (data) => fetchData("http/survey", "POST", data);

export const getGeo = () => fetchData("http/geo", "GET");

export const setAdwords = (data, headers) =>
  fetchData("http/adwords", "POST", data, headers);

export const doUpgrade = (data, headers) =>
  fetchData("http/upgrade", "POST", data, headers);
